import { gql } from 'glimmer-apollo';

export const TWITCH_STREAMS_QUERY = gql`
  query TwitchStreams($context: LivestreamContextInput!) {
    livestreams(context: $context) {
      streams {
        id
        userId
        userName
        userDisplayName
        gameId
        gameName
        title
        viewerCount
        startedAt
        language
        thumbnailUrl
        profileImageUrl
        isLive
        tags
      }
      totalCount
    }
  }
`;

export const TWITCH_STREAMS_SIMPLE_QUERY = gql`
  query TwitchStreamsSimple($filter: TwitchStreamFilter, $limit: Int) {
    twitchStreams(filter: $filter, limit: $limit) {
      id
      userId
      userName
      userDisplayName
      gameId
      gameName
      title
      viewerCount
      startedAt
      language
      thumbnailUrl
      profileImageUrl
      isLive
      tags
    }
  }
`;